import {
  UNDEFINED_STATUS
} from './action-status';

import {
  UNDEFINED_CONTENT_TYPE
} from './active-content-type';

export default function initialState() {
  return {
    moduleName: 'wre-dashboard',
    activeNavMenuItemId: '',
    storageSpace: { used: 0, total: 0, indicatorType: 'SPACE_LEFT' },
    setupArchivePasswordStatus: UNDEFINED_STATUS,
    contentItems: [],
    fetchStorageSpaceStatus: UNDEFINED_STATUS,
    fetchContentItemsStatus: UNDEFINED_STATUS,
    postLoginOpenArchiveId: { id: '', baseName: '' },
    postLoginOpenNavMenuId: { id: '' },
    activeContentType: UNDEFINED_CONTENT_TYPE,
    sharedContentItems: [],
    fetchSharedContentItemsStatus: UNDEFINED_STATUS,
    userSubscription: {},
    userSubscriptionType: '',
    appFeatures: {},
    fileVersions: [],
    fetchFileVersionsStatus: UNDEFINED_STATUS,
    sharedLink: {},
    createSharedLinkStatus: UNDEFINED_STATUS,
    deleteSharedLinkStatus: UNDEFINED_STATUS,
    sharedLinkSettings: {},
    fetchSharedLinkStatus: UNDEFINED_STATUS,
    updateSharedLinkStatus: UNDEFINED_STATUS,
    searchEnabled: false,
    brandName: 'Acronis Cloud',
    spaceFreeAfterCleanup: 0,
    searchResultReceived: false,
    activeVersionPath: '',
    activeVolumePath: '',
    activeFolderItem: { path: '', displayName: '', isSearchFolder: false },
    subAccountItems: [],
    volumeSbMachines: [],
    fetchSubAccountItemsStatus: UNDEFINED_STATUS,
    subAccountArchives: [],
    fetchSubAccountArchivesStatus: UNDEFINED_STATUS,
    activeSubAccountDisplayName: '',
    activeSubAccountId: 0,
    activeVolumeSbSubAccountId: 0,
    activeVolumeSubscription: false,
    checkSubAccountStatus: UNDEFINED_STATUS
  };
}
